<template>
  <div class="edit-collection">
    <span
    class="edit-collection__header">
      {{ labelForEdit }}
    </span>
    <div class="edit-collection__content">
      <!-- EDIT-->
      <input
      v-if="action === 'rename'"
      v-model.trim="nameNewCollection"
      type="text"
      class="edit-collection__input"
      :placeholder="$t('new_name')">
      <!-- DELETE -->
      <span
      v-if="action === 'delete'"
      class="edit-collection__delete-text">{{ textForDetele }}</span>
    </div>
    <button
    class="edit-collection__button"
    :class="isDisabledButton && action !== 'delete' && 'edit-collection__button_disabled'"
    @click="saveAction">
      {{ labelForSaveButton }}
    </button>
  </div>
</template>

<script>

export default {
  name: 'EditCollectionModal',
  props: {
    action: {
      type: String,
      default: null,
    },
    compilation: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    nameNewCollection: '',
  }),
  methods: {
    saveAction() {
      if (this.action === 'delete') {
        this.$store.dispatch('compilations/deleteCompilation', this.compilation.id)
          .then(() => {
            this.$emit('close');
            this.$store.dispatch('app/setSnackBar', { text: this.$t('Compilation has been deleted', { compilation: this.compilation.name }) });
            if (this.$route.name !== 'compilations') {
              this.$router.push({ name: 'compilations' });
            }
          })
          .catch(() => {
            this.$emit('close');
            this.$store.dispatch('app/setSnackBar',
              {
                text: this.$t('An error occurred when deleting the collection. Reload the page and try again'),
                error: true,
              });
          });
      }
      if (this.action === 'rename') {
        this.$store.dispatch('compilations/renameCompilation', { id: this.compilation.id, name: this.nameNewCollection })
          .then(() => {
            this.$store.dispatch('app/setSnackBar', { text: this.$t('The compilation has been renamed') });
            this.$emit('close');
          })
          .catch(() => {
            this.$emit('close');
            this.$store.dispatch('app/setSnackBar',
              {
                text: this.$t('An error occurred when changing the name of the collection. Reload the page and try again'),
                error: true,
              });
          });
      }
    },
  },
  computed: {
    isDisabledButton() {
      return this.nameNewCollection === '';
    },
    labelForEdit() {
      if (this.action === 'delete') {
        this.$t('Deleting a compilation');
      }
      if (this.action === 'rename') {
        return `${this.$t('Enter a new name for the compilation')} "${this.compilation.name}"`;
      }
      return '';
    },
    textForDetele() {
      return `${this.$t('Are you sure you want to delete a compilation')} "${this.compilation.name}"?`;
    },
    labelForSaveButton() {
      if (this.action === 'delete') {
        return this.$t('delete');
      }
      if (this.action === 'rename') {
        return this.$t('save');
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-collection {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  @include between-elements {
    margin-bottom: 30px;
  }
}

.edit-collection__header {
  font-size: 22px;
  color: $primary-black;
  max-width: 400px;
}

.edit-collection__content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.edit-collection__button {
  cursor: pointer;
  width: 296px;
  height: 52px;
  font-size: 16px;
  outline: none;
  border: none;
  color: $primary-white;
  background: $primary-blue;
  border-radius: 40px;
  &_disabled {
    pointer-events: none;
    background: $primary-lightgray;
  }
}

.edit-collection__input {
  min-width: 300px;
  max-width: 500px;
  padding: 7px 40px 7px 16px;
  border: 1px solid $border-color-primary;
  border-radius: 8px;
  background: $primary-white;
  box-sizing: border-box;
  font-size: 14px;
  &:focus {
    outline: none;
  }
}

.edit-collection__delete-text {
  width: 600px;
}
</style>
